import { AlchemyProviderConfigSchema, createAlchemyPublicRpcClient, createAlchemySmartAccountClientFromExisting, } from "@account-kit/infra";
import { accountLoupeActions, createMultiOwnerModularAccount, multiOwnerPluginActions, pluginManagerActions, } from "@account-kit/smart-contracts";
import { custom, } from "viem";
/**
 * Creates a modular account Alchemy client with the provided configuration.
 *
 * @example
 * ```ts
 * import { createModularAccountAlchemyClient } from "@account-kit/smart-contracts";
 * import { sepolia } from "@account-kit/infra";
 * import { LocalAccountSigner } from "@aa-sdk/core";
 * import { generatePrivateKey } from "viem"
 *
 * const alchemyAccountClient = await createModularAccountAlchemyClient({
 *  apiKey: "your-api-key",
 *  chain: sepolia,
 *  signer: LocalAccountSigner.privateKeyToAccountSigner(generatePrivateKey())
 * });
 * ```
 *
 * @param {AlchemyModularAccountClientConfig} config The configuration for creating the Alchemy client
 * @returns {Promise<AlchemySmartAccountClient>} A promise that resolves to an `AlchemySmartAccountClient` configured with the desired plugins and actions
 */
export async function createModularAccountAlchemyClient(config) {
    const { chain, opts, ...connectionConfig } = AlchemyProviderConfigSchema.parse(config);
    const client = createAlchemyPublicRpcClient({
        chain,
        connectionConfig,
    });
    const account = await createMultiOwnerModularAccount({
        transport: custom(client),
        ...config,
    });
    return createAlchemySmartAccountClientFromExisting({
        ...config,
        client,
        account,
        opts,
    })
        .extend(multiOwnerPluginActions)
        .extend(pluginManagerActions)
        .extend(accountLoupeActions);
}
//# sourceMappingURL=alchemyClient.js.map